import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfFormOrderService {

  private baseURL!: string;

  constructor(private httpClient: HttpClient) {}

  setBaseURL(baseURL: string): void {
    this.baseURL = baseURL;
  }

  loadPdfForms(params: PdfFormLoadParams): Observable<PdfFormOrderResponse> {
    const body = new HttpParams()
      .set('tax_year', params.taxYear)
      .set('screen_key', params.screenKey)
      .set('scenario', params.scenario)
      .set('jcd_key', params.jcdKey)
      .set('jcd_ta_key', params.jcdTaKey)
      .set('activity_key', params.activityKey)
      .set('screen_type', params.screenType || 'grid')
      .set('is_locked', params.isLocked || 'N')
      .set('issue_id', params.issueId || '')
      .set('issue_short_desc', params.issueShortDesc || '')
      .set('issue_id_for_tx_save', params.issueIdForTxSave || '')
      .set('return_type', params.returnType);

    return this.httpClient.post<any>(
      `${this.baseURL}/loadGridJson?grid_id=6214&action_id=33528`,
      body.toString(),
      { 
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }
    ).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  savePdfFormOrder(
    params: PdfFormSaveParams,
    formOrderData: Array<{ FORM: string; FORM_ORDER: number }>
  ): Observable<any> {
    const url = `${this.baseURL}/saveJsonObject?action_id=33535`;

    const body = new URLSearchParams();
    
    body.set('tax_year', params.tax_year);
    body.set('return_type', params.return_type);
    body.set('screen_key', params.screen_key);
    body.set('scenario', params.scenario);
    body.set('jcd_key', params.jcd_key);
    body.set('jcd_ta_key', params.jcd_ta_key);
    body.set('activity_key', params.activity_key);
    body.set('screen_type', params.screen_type);
    body.set('is_locked', params.is_locked);
    body.set('scenarioCode', params.scenarioCode);
    body.set('is_issue_key_enabled', params.is_issue_key_enabled);
    
    body.set('form_order_json', JSON.stringify(formOrderData));

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.httpClient.post<any>(url, body.toString(), httpOptions);
  }
}

export interface PdfFormLoadParams {
  taxYear: string;
  returnType: string;
  screenKey: string;
  scenario: string;
  jcdKey: string;
  jcdTaKey: string;
  activityKey: string;
  screenType?: string;
  isLocked?: string;
  scenarioCode?: string;
  isIssueKeyEnabled?: string;
  issueId?: string;
  issueShortDesc?: string;
  issueIdForTxSave?: string;
}

export interface PdfFormSaveParams {
  tax_year: string;
  return_type: string;
  screen_key: string;
  scenario: string;
  jcd_key: string;
  jcd_ta_key: string;
  activity_key: string;
  screen_type: string;
  is_locked: string;
  scenarioCode: string;
  is_issue_key_enabled: string;
}

export interface PdfFormItem {
  FORM: string;
  FORM_ORDER: number;
  object_id: string;
}

export interface PdfFormOrderResponse {
  data: PdfFormItem[];
  callSuccess: string;
  settings: any;
  header: any[];
}

